import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { InsurancePolicy } from 'src/interfaces/insurancePolicy'

interface Props {
  isOpen: boolean
  policy: InsurancePolicy | null
  isDeleting: boolean
  onConfirm(): void
  onClose(): void
}

const DeleteInsurancePolicyModalComponent = ({
  isOpen,
  policy,
  isDeleting,
  onConfirm,
  onClose,
}: Props) => {
  if (!policy) {
    return null
  }

  return (
    <CommonModal
      isOpen={isOpen}
      title="Delete this insurance policy?"
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" disabled={isDeleting} onClick={onClose}>
            Cancel
          </Button>
          {/* `red` is the shared Button's destructive variant. */}
          <Button
            size="small"
            color="red"
            loading={isDeleting}
            disabled={isDeleting}
            onClick={onConfirm}
            data-testid="insurance-policy-delete-confirm-button"
          >
            Delete policy
          </Button>
        </Fragment>
      }
    >
      <div css={tw`flex flex-col gap-2`}>
        <Typography variant="body2">
          {policy.name} and the products inside it will be removed from this customer.
        </Typography>
        <Typography variant="body2" css={tw`text-shades-500`}>
          A policy still used by an onboarding template cannot be deleted — remove the insurance
          steps that reference it first.
        </Typography>
      </div>
    </CommonModal>
  )
}

export const DeleteInsurancePolicyModal = memo(DeleteInsurancePolicyModalComponent)
